import { render, staticRenderFns } from "./visit-module.vue?vue&type=template&id=0bee85a3&scoped=true"
import script from "./visit-module.vue?vue&type=script&lang=js"
export * from "./visit-module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee85a3",
  null
  
)

export default component.exports